import React from 'react'

const WscLogo = (): JSX.Element => {
  return (
    <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="player">
      <path d="M9.56251 7.75044L4.99012 0H0L6.39571 10.8487H9.5611V7.75044H9.56251Z" fill="white" />
      <path d="M16.1276 7.75044L11.5566 0H6.56506L12.9608 10.8487H16.1276V7.75044Z" fill="white" />
      <path d="M17.6531 1.80397L16.0711 1.81226V5.36909L19.2365 0H12.9029" fill="#E5FF00" />
    </svg>
  )
}

export default WscLogo
